import { render, staticRenderFns } from "./emBaseDetail.vue?vue&type=template&id=fda4a562&scoped=true&"
import script from "./emBaseDetail.vue?vue&type=script&lang=js&"
export * from "./emBaseDetail.vue?vue&type=script&lang=js&"
import style0 from "./emBaseDetail.vue?vue&type=style&index=0&id=fda4a562&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fda4a562",
  null
  
)

export default component.exports